import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import type { FormSubmitEventTarget } from '@/types/dom';
import { updateParams } from '@/redux/app/actions/navigation';

import { AppNavigatorParamsContext } from '@/lib/navigation';

export const InboxSearchForm = () => {
  const dispatch = useDispatch();
  const { search: searchParam = '', archived: archivedParam } = useContext(AppNavigatorParamsContext);
  const [inputValue, setInputValue] = useState(searchParam);

  useEffect(() => {
    setInputValue(searchParam);
  }, [searchParam]);

  const handleInput = (e) => {
    setInputValue(e.currentTarget.value);
  };

  const handleSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>&{ target: FormSubmitEventTarget }) => {
      event.preventDefault();
      const { elements } = event.target;
      const search = elements.namedItem('search').value.trim();
      dispatch(updateParams({ search, ...(!archivedParam && search && { archived: 'on' }) }));
    },
    [dispatch],
  );

  return (
    <form id="search-form" onSubmit={handleSubmit}>
      <div className="container">
        <input
          type="text"
          name="search"
          className="ticket-search"
          placeholder="Search Inbox"
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          onChange={handleInput}
          value={inputValue}
        />
      </div>
    </form>
  );
};
